export const UploadActionEnum = {
  ONLYUPLOAD: 0,
  APKPARSE: 1,
  IMAGEUPLOAD: 2,
};

export const ModuleNameEnum = {
  DOCUMENT: "document",
};

export const PendingStatus = {
  PENDING: 0,
  COMPLETE: 1,
  REJECTED: 2,
  ARCHIVE: 3,
};

export const FIELDTYPE = {
  TEXTBOX: 0,
  CHECKBOX: 1,
  DROPBOX: 2,
  INITIAL: 3,
  SIGNATURE: 4,
};

export const LOGTYPE = {
  SeLectLogType: null,
  LOGIN: 1,
  LOGOUT: 2,
  OWN_PROFILE: 3,
  SIGNATURE_MANAGEMENT: 4,
  USER_MANAGEMENT: 5,
  SIGNING_TASK: 6,
  DOWNLOADS: 7,
  UPLOADS: 8,
  SIGNING_PACKAGE_MANAGEMENT: 9,
  STORAGE_PACKAGE_MANAGEMENT: 10,
  DASHBOARD: 11,
  eKYC: 12,
  OTHER: 0,
};

export function getOption() {
  let options = [];

  let keys = Object.keys(LOGTYPE);

  keys.map((v, i) => {
    options.push({ id: v, title: v, value: LOGTYPE[v] });
  });
  // console.log(options);

  return options;
}
